export class ValidaSesionPeticion {
	public token:string = "";
	public codCliente: string = "";
}
